import { useEffect } from 'react';

type CartTYP = {
	orderId: string;
	grandTotal: number;
};

declare global {
	interface Window {
		cartTYP?: CartTYP;
	}
}

export const useTrackBlueTriangleCartTYP = ({
	orderId,
	grandTotal,
}: {
	orderId?: string;
	grandTotal?: string | number;
}) => {
	useEffect(() => {
		if (typeof window === 'undefined') return;
		if (!orderId || grandTotal === undefined || grandTotal === '') return;

		const parsedGrandTotal = typeof grandTotal === 'number' ? grandTotal : parseFloat(grandTotal);
		if (Number.isNaN(parsedGrandTotal)) return;

		window.cartTYP = { orderId, grandTotal: parsedGrandTotal };

		return () => {
			delete window.cartTYP;
		};
	}, [orderId, grandTotal]);
};
